import angular from "angular";
import addChangeItemCategoryDialogTemplate from "./AddChangeItemCategoryDialog.template.html";

export default angular
  .module('csm.books.com.AddChangeItemCategoryDialog', [])
  .service('AddChangeItemCategoryDialog', AddChangeItemCategoryDialogService)
  .name;
  
/*******************************************************************************
 * Service: AddChangeItemCategory
 *
 * Dialog to create or manage an existing Item Category object.
 *******************************************************************************/
/* @ngInject */ function AddChangeItemCategoryDialogService($uibModal, $q, Alert, BooksSvc, BusyScreen) {
  /****************************************************************************
   * show */
  /**
   *  Show the model dialog for reviewing and managing an Item Category.
   *
   * @param  categoryID   ItemCategory ID to update. 0 or Undefined = new
   * @return              Promise that resolves when a category is saved with the
   *                      new/updated ItemCategory
   ****************************************************************************/
  this.show = function (categoryID) {
    BusyScreen.setBusy(true);

    /*----------------------------------------------------------------*/
    /* When a categoryID has been provided, attempt to load the       */
    /* ItemCategory, otherwise a new category object is to be managed */
    /*----------------------------------------------------------------*/
    return $q
      .when(
        categoryID
          ? BooksSvc.getItemCategory(categoryID).then(function (resp) {
              return resp.data;
            })
          : {}
      )
      .then(function (category) {
        BusyScreen.setBusy(false);

        /*---------------------------------*/
        /* Alert when no category is found */
        /*---------------------------------*/
        if (!category) {
          Alert.info('Item Category not found', 'Category Missing', true);
          return $q.reject();
        }

        /*--------------------------------------------*/
        /* When new or existing category, open modal. */
        /*--------------------------------------------*/
        return $uibModal.open({
          template: addChangeItemCategoryDialogTemplate,
          size: 'md',
          backdrop: 'static',
          controller: function ($scope, BusyScreen) {
            /** Object to store category data **/ $scope.category =
              category;
            /** Indication of new category **/ $scope.isNew =
              !$scope.category.id;
            /** CSMValidators validate fields */ $scope.validators = {};

            /********************************************************************
             * commit */
            /**
             * Commit button handler. Ensure the data is valid before performing
             * the available action. The modal is resolved with the appropriate
             * add/new button.
             ********************************************************************/
            $scope.commit = function () {
              if (!$scope.validators.validate()) return;

              BusyScreen.setBusy(true);
              BooksSvc.saveItemCategory($scope.category)
                .then(
                  function (resp) {
                    $scope.category.id = Number(resp.data);
                    $scope.$close($scope.category);
                  },
                  /*---------------------*/
                  /* Save Error Handling */
                  /*---------------------*/
                  function (resp) {
                    Alert.error(
                      resp.parsedResponse
                        ? resp.parsedResponse.message()
                        : resp.statusText,
                      'Cannot Save Category'
                    );
                  }
                )
                .finally(function () {
                  BusyScreen.setBusy(false);
                });
            };

            /*********************************************************************
             * getTitle */
            /**
             * Returns text to display for the modal title.
             *
             * @return  String  Display correct title for dialog.
             **********************************************************************/
            $scope.getTitle = function () {
              return $scope.isNew
                ? 'Add New Item Category'
                : 'Update Item Category';
            };
          }
        }).result;
      });
  };
}